module.exports = __webpack_public_path__ + "static/media/sydney.717a2873.jpg";